module.exports = __webpack_public_path__ + "img/electronic_pending_zone_selected.b40601e4.svg";